export const BILLING_PLANS = [
  { purchaseType: "consumer_content", billingInterval: "month", name: "Consumer monthly", amount: 500,
    description: "All web content for personal use. Analytics and join codes are not included." },
  { purchaseType: "consumer_content", billingInterval: "year", name: "Consumer annual", amount: 2000,
    description: "All web content for personal use. Analytics and join codes are not included." },
  { purchaseType: "classroom_license", billingInterval: "year", name: "Web educator", amount: 20000,
    description: "Web content, educator analytics, and web student join codes." },
  { purchaseType: "site_license", billingInterval: "year", name: "Site license", amount: 120000,
    description: "Unlimited web and VR access for your site, educator analytics, and student join codes." },
];

export const formatPlanPrice = (amount, billingInterval, currency = "usd") =>
  `${new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 2 }).format(amount / 100)} / ${billingInterval}`;

export const getAccountPlanName = ({ subscriptionPurchaseType, roleName, subscriptionStatus }) => {
  if (subscriptionStatus === "trial") return "Educator trial";
  if (subscriptionStatus === "free" || !subscriptionStatus) return "Free account";
  if (subscriptionPurchaseType === "site_license" || String(roleName).toLowerCase() === "educatorsite") return "Site license";
  if (subscriptionPurchaseType === "classroom_license" || String(roleName).toLowerCase() === "educator") return "Web educator";
  if (subscriptionPurchaseType === "consumer_content" || String(roleName).toLowerCase() === "consumer") return "Consumer content";
  return "10k Science access";
};

// Older classroom checkouts did not include product or interval metadata.
export const matchesPurchasedPlan = (subscription, purchaseType, billingInterval) =>
  (subscription?.purchaseType || "classroom_license") === purchaseType &&
  (subscription?.billingInterval || "year") === billingInterval;
